import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTelephone: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconTelephone"><Path d="M3 3V5.8125C3 14.2003 9.79968 21 18.1875 21H21V14.6302L15.9769 12.1187L14.4051 13.6905C12.4366 12.8075 11.1925 11.5634 10.3095 9.59491L11.8813 8.02309L9.36978 3H3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTelephone;
